import { getFullName } from "@vega-api/custom/utils/user";

import { useGpUsersForDealSearch } from "./useGpUsersForDealSearch";

type UseOpportunityOwnerSearchParams = {
  dealId: string;
};

export const useOpportunityOwnerSearch = ({
  dealId,
}: UseOpportunityOwnerSearchParams) => {
  const {
    searchValue,
    setSearchValue,
    data: searchGpUsersData,
    isPending,
  } = useGpUsersForDealSearch({ dealId });

  const searchOptions = searchGpUsersData.map((user) => ({
    id: user.id,
    searchValue: getFullName(user.fullName),
    content: user.email,
    user: {
      id: user.id,
      firstName: user.fullName.firstName,
      lastName: user.fullName.lastName,
      email: user.email,
    },
  }));

  return {
    searchValue,
    setSearchValue,
    searchOptions,
    isOpportunityOwnerSearchLoading: isPending,
  };
};
